<template>
    <div class="flex space-x-2 mb-2">
        <span class="dark:text-neutral-300"> {{ time }} </span>
        <span class="dark:bg-neutral-700 w-full h-6 rounded-xl" />
    </div>
    <div class="flex justify-between w-full">
        <span
            class="cursor-pointer"
            @click="handleRemove"
        >
            <Unicon
                name="trash-alt"
                class="h-6 w-6 text-chat-primary hover:text-chat-black"
                aria-hidden="true"
            />
        </span>
        <span
            class="cursor-pointer"
            @click="handlePlayPause"
        >
            <Unicon
                name="pause-circle"
                class="h-6 w-6 text-red-400 hover:text-red-700"
                aria-hidden="true"
            />
        </span>
        <span
            class="cursor-pointer "
            @click="handleSend"
        >
            <Unicon
                name="message"
                class=" h-6 w-6 text-chat-primary hover:text-chat-black"
                aria-hidden="true"
            />
        </span>
    </div>
</template>
<script setup>
    import { ref } from 'vue'

    const time = ref('0:15')
    function handleRemove() {
        console.log('remove')
    }
    function handlePlayPause() {
        console.log('play pause')
    }
    function handleSend() {
        console.log('send')
    }
</script>
